import { useHistory } from 'react-router-dom'
import Select from 'react-select';
export const AddQuotes = () => {
    const history = useHistory()
    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <form className="control-form">
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label" >Service</label>
                                    <Select
                                        options="Land"
                                        value="land"
                                    />
                                </div>

                                <div className="mb-3 col-6">
                                    <label className="form-label" >Origin</label>
                                    <input
                                        required=""
                                        type="text"
                                        min="0"
                                        className='form-control'
                                        placeholder="Origin"
                                    />
                                </div>

                            </div>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label" >Destination</label>
                                    <input
                                        required=""
                                        type="text"
                                        min="0"
                                        className='form-control'
                                        placeholder="Destination"
                                    />
                                </div>
                                <div className="mb-3 col-6">
                                    <div className="row">
                                        <div className="col-4">
                                            <label className="form-label">Weight</label>
                                            <input
                                                required=""
                                                type="number"
                                                min="0"
                                                className='form-control'
                                                placeholder="91"
                                            />
                                        </div>

                                        <div className="col-4">
                                            <label className="form-label">Volume</label>
                                            <input
                                                required=""
                                                type="number"
                                                min="0"
                                                className='form-control'
                                                placeholder="91"
                                            />
                                        </div>

                                        <div className="col-4">
                                            <label className="form-label">Packages (No.)</label>
                                            <input
                                                required=""
                                                type="number"
                                                min="0"
                                                className='form-control'
                                                placeholder="91"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">Customer Name</label>
                                    <input
                                        required=""
                                        type="text"
                                        className='form-control'
                                        placeholder="Enter Customer Name"
                                    />

                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Email</label>
                                    <input
                                        className='form-control'
                                        type="email"
                                        placeholder="Enter Email"
                                    />

                                </div>
                            </div>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">Special Request</label>
                                    <input
                                        className='form-control'
                                        type="text"
                                        placeholder="Enter Request here.."
                                    />

                                </div>

                            </div>

                            <div className="mt-3 d-flex justify-content-between">
                                <button
                                    className="btn btn-danger w-sm waves-effect waves-light"
                                    type="button"
                                    onClick={() => history.goBack()}
                                >Back</button>
                                <button className="btn btn-primary w-sm waves-effect waves-light"
                                    type="button"

                                >Submit</button>
                            </div>
                        </form>
                        {/* <Loader isShow={loader} /> */}
                    </div>
                </div>
            </div>
        </div>
    )
}
